import { config as v3Config } from '@tamagui/config/v3';
import { createTamagui } from 'tamagui';

/**
 * mrrmlab design system. Built on top of @tamagui/config/v3 so we get a
 * complete token set (sizes, spacing, radii, fonts, colors) for free, then
 * layer mrrmlab-specific brand tints on top.
 *
 * Web (Vite + @tamagui/vite-plugin) and mobile (Expo + @tamagui/babel-plugin)
 * both compile this config at build time and tree-shake unused tokens.
 */
export const tamaguiConfig = createTamagui({
  ...v3Config,
  themes: {
    ...v3Config.themes,
    mrrmlab_light: {
      ...v3Config.themes.light,
      background: '#FAFAFA',
      color: '#0F1419',
      primary: '#2563EB',
      primaryForeground: '#FFFFFF',
    },
    mrrmlab_dark: {
      ...v3Config.themes.dark,
      background: '#0B0F19',
      color: '#F5F5F5',
      primary: '#60A5FA',
      primaryForeground: '#0B0F19',
    },
  },
});

export type AppTamaguiConfig = typeof tamaguiConfig;

// Tamagui's babel/vite plugins look for `export default` (or `export const config`)
// when statically loading the config file at compile time. Re-export the named
// binding under both forms so existing consumers keep using `tamaguiConfig`
// while the plugins still find what they need.
export { tamaguiConfig as config };
export default tamaguiConfig;

declare module 'tamagui' {
  // eslint-disable-next-line @typescript-eslint/no-empty-object-type -- tamagui module augmentation requires interface form
  interface TamaguiCustomConfig extends AppTamaguiConfig {}
}
